/* eslint-disable max-len */
import React from 'react';
import {
  Box, Card, CardActionArea, Typography, CardMedia, CardContent, CardActions, Button,
} from '@mui/material';
import scratch from '../../../resources/kid3.jpg';
import javascript from '../../../resources/code2.jpg';
import probSolving from '../../../resources/kid5.jpg';

const Curriculum = () => (
  <Box
    id="curriculum"
    sx={{
      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '40px 0',
    }}
  >
    <Box sx={{ width: '100%', textAlign: 'center', padding: '30px 0' }}>
      <Typography sx={{
        background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
      }}
      >
        The Curriculum
      </Typography>
    </Box>
    <Box sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '14px', sm: '0' },
    }}
    >
      <Card sx={{ maxWidth: { xs: '100%', sm: '30%' } }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="140"
            image={scratch}
            alt="Scratch Programming image"
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
              }}
            >
              Scratch Programming
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Scratch is an object-oriented coding course for young kids, designed to improve problem-solving skills and creative thinking.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary">
            Beginner
          </Button>
        </CardActions>
      </Card>
      <Card sx={{ maxWidth: { xs: '100%', sm: '30%' } }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="140"
            image={javascript}
            alt="JavaScript image"
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
              }}
            >
              JavaScript
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Kids will learn the foundations of JavaScript, one of the most popular coding languages. During this course they will learn HTML and CSS.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary">
            Beginner
          </Button>
        </CardActions>
      </Card>
      <Card sx={{ maxWidth: { xs: '100%', sm: '30%' } }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="140"
            image={probSolving}
            alt="problem solving image"
          />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
              }}
            >
              Problem Solving
            </Typography>
            <Typography variant="body2" color="text.secondary">
              In this course, kids learn and develop problem solving skills through our interactive games & simulations while collaborating in small groups.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary">
            Beginner
          </Button>
        </CardActions>
      </Card>
    </Box>
  </Box>
);

export default Curriculum;

// <Box sx={{ width: '80%', bgcolor: 'transparent', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', margin: '20px 0', gap: { xs: '20px', sm: '0' } }}>
//   <Box sx={{ width: {xs: '100%', sm: '50%'} }}>
//     <Typography sx={{ background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: { xs: '30px', sm: '50px' }, fontWeight: '600', lineHeight: {xs: '40px', sm: '75px'} }}>EMBRACE THE CHAOS FAMILY ONE</Typography>
//     <Typography sx={{ color: '#fff', fontSize: '25px', fontWeight: '500', lineHeight: '70px' }}>LEVEL: BEGINNER</Typography>
//     <Typography>Scratch is an object-oriented coding course for young kids, designed to improve problem-solving skills and creative thinking.</Typography>
//   </Box>
//   <Box sx={{ width: {xs: '100%', sm: '50%'} }}>
//     <CardMedia
//       component="img"
//       width= '100%'
//       image={scratch}
//       alt="curriculm image"
//       sx={{ border: '4px solid #F49867', borderRadius: '4px' }}
//     />
//   </Box>
// </Box>
